// extracted by mini-css-extract-plugin
export default {"container":"reviews_container__8rglO","emptyPage":"reviews_emptyPage__wSq09","content":"reviews_content__jD5vr","reviews":"reviews_reviews__5XuQl","line":"reviews_line__3EaeF"};